import { useRef, useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

// Assinatura desenhada na tela (mouse/dedo). onChange recebe dataURL PNG ou null.
export const SignatureCanvas = ({ onChange }) => {
  const canvasRef = useRef(null);
  const desenhando = useRef(false);
  const [vazia, setVazia] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#102a4a";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: (p.clientX - r.left) * (canvasRef.current.width / r.width), y: (p.clientY - r.top) * (canvasRef.current.height / r.height) };
  };
  const inicio = (e) => {
    e.preventDefault();
    desenhando.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const mover = (e) => {
    if (!desenhando.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    if (vazia) setVazia(false);
  };
  const fim = () => {
    if (!desenhando.current) return;
    desenhando.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };
  const limpar = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setVazia(true);
    onChange(null);
  };

  return (
    <div className="space-y-1">
      <canvas ref={canvasRef} width={600} height={180} data-testid="assinatura-canvas"
        className="w-full h-32 bg-white border-2 border-dashed border-slate-300 rounded-lg touch-none"
        onMouseDown={inicio} onMouseMove={mover} onMouseUp={fim} onMouseLeave={fim}
        onTouchStart={inicio} onTouchMove={mover} onTouchEnd={fim} />
      <div className="flex items-center justify-between">
        <p className="text-[11px] text-slate-400">{vazia ? "Assine com o dedo ou mouse no quadro acima" : "Assinatura registrada"}</p>
        <Button type="button" variant="ghost" size="sm" onClick={limpar} data-testid="btn-limpar-assinatura" className="text-xs h-7">Limpar</Button>
      </div>
    </div>
  );
};
